import { cleartaxAxios } from '../../http-common';
import { trackEventInNetcore } from '../../utils/netcore';
import { CALCULATOR_DATA } from './types';

class PaytaxServices {
  sendTaxMail<T>(email: string, emailData: T, slug: string, year?: number) {
    trackEventInNetcore('paytax_email_sent', { email, emailData });
    let url = `/f/itr/${slug}?Email=${email}`;
    if (year != undefined) {
      url += `&Year=${year}`;
    }
    return cleartaxAxios.post(url, emailData);
  }
  async getCalculation(endpoint: string, data: CALCULATOR_DATA) {
    try {
      const response = await cleartaxAxios.post(endpoint, data);
      return response.data;
    } catch (error) {
      console.error('Error making API request:', error);
      throw error;
    }
  }
}
export default new PaytaxServices();
